import Beneficios from '../../Features/Beneficios';

const ConfirmacionDescripcionProductos = ({ tieneClubLN }) => {
    const descripcionTieneClubLN = '+ Club LA NACION.';
    return (
        <>
            <div className="--mb-16">
                <strong>Ya contás con Acceso Digital {tieneClubLN && descripcionTieneClubLN}</strong>
            </div>
        </>
    );
};

export default ConfirmacionDescripcionProductos;
